import { render, staticRenderFns } from "./TranProgramModuleList.vue?vue&type=template&id=2afa6ae9&scoped=true"
import script from "./TranProgramModuleList.vue?vue&type=script&lang=js"
export * from "./TranProgramModuleList.vue?vue&type=script&lang=js"
import style0 from "./TranProgramModuleList.vue?vue&type=style&index=0&id=2afa6ae9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afa6ae9",
  null
  
)

export default component.exports